let SliderArr;
class Slider {
  constructor(cont = document.querySelector("[slider-cont]"), isInfinite = false) {
    this.isInfinite = isInfinite;
    this.elements = {
      cont: cont
    };

    this.len = 0;
    this.curIndex = this.isInfinite ? 1 : 0; // dot, caption index
    this.fakeAddition = this.isInfinite ? 2 : 0; // fake frame index
    this.isChanging = false;

    this.touchPos = {
      x: 0,
      y: 0
    };

    this.touchPosInitial = {
      x: 0,
      y: 0
    };

    this.movingTreshold = 100;

    this.frameRate = 718 / 760;
    this.frameWidth;
    this.frameHeight;

    this.isChanging = false;

    this.init();
  }

  init() {
    this.getElements();
    // render slider items & dots
    // assign frameBox size
    this.setHeight();

    // activate first index
    if (!this.isInfinite) {
      // this.toggleArrow(0)
    }
    if (this.elements.numIndexTotal) {
      this.elements.numIndexTotal.textContent = this.getFormattedNumber(this.len - this.fakeAddition);
    }

    // event handler
    this.attachEvent();

    window.addEventListener("resize", () => this.setHeight());
  }

  getElements() {
    const { cont } = this.elements;
    let frame = cont.querySelector("[slider-frame]");
    let frameItems = cont.querySelectorAll("[slider-frame-items]");
    frameItems = [...frameItems];

    let dots = cont.querySelectorAll("[slider-dots]");
    dots = [...dots];

    let leftArrow = cont.querySelector("[slider-arrow-left]");
    let rightArrow = cont.querySelector("[slider-arrow-right]");

    let numIndex = cont.querySelector("[slider-num-index]");
    let numIndexTotal = cont.querySelector("[slider-num-index-total]");

    let textBox = {
      title: cont.querySelector("[slider-title]"),
      desc: cont.querySelector("[slider-desc]"),
      author: cont.querySelector("[slider-author]")
    }

    this.elements = {
      ...this.elements,
      frame,
      frameItems,
      dots,
      leftArrow,
      rightArrow,
      numIndex,
      numIndexTotal,
      textBox
    }

    this.len = this.elements.frameItems.length;
  }

  setHeight() {
    // check frame size
    const { frame, frameItems, dots } = this.elements;
    
    let frameMarginLeft = getComputedStyle(frameItems[0]).marginLeft;
    let frameMarginRight = getComputedStyle(frameItems[0]).marginRight;

    if (frameMarginLeft.includes("px")) {
      frameMarginLeft = frameMarginLeft.split("px")[0];
    }

    if (frameMarginRight.includes("px")) {
      frameMarginRight = frameMarginRight.split("px")[0];
    }

    frameMarginLeft = parseFloat(frameMarginLeft);
    frameMarginRight = parseFloat(frameMarginRight);

    this.frameWidth = frame.offsetWidth + frameMarginLeft + frameMarginRight;

    // this.frameHeight = this.frameWidth / this.frameRate;
    // frame.style.height = this.frameHeight.toFixed(2) + "px";

    frame.style.transform = `translate3d(${0 - this.frameWidth * this.curIndex}px, 0, 0)`;
  }

  attachEvent() {
    const { leftArrow, rightArrow, dots, frame } = this.elements;

    // arrow event
    /* leftArrow.addEventListener("click", (e) => {
      e.preventDefault();
      if (this.isChanging) return;

      this.curIndex -= 1;
      if (this.curIndex < 0) {
        this.curIndex = this.len - 1;
      }

      this.changeHandler(this.curIndex);
    });

    rightArrow.addEventListener("click", (e) => {
      e.preventDefault();
      if (this.isChanging) return;

      this.curIndex += 1;

      this.curIndex %= this.len;

      this.changeHandler(this.curIndex);
    }); */

    // dot event
    dots.forEach((cur, ind) => {
      cur.addEventListener("click", (e) => {
        e.preventDefault();
        if (this.isChanging) return;
        
        this.changeHandler(ind + (this.fakeAddition / 2));
      });
    })

    frame.addEventListener("touchstart", (e) => this.touchStart(e), { capture: true });

    frame.addEventListener("touchmove", (e) => this.touchMove(e), { capture: true });

    frame.addEventListener("touchend", (e) => this.touchEnd(e), { capture: true });
  }

  getDotsIndex(targetInd) {
    if (!this.isInfinite) return targetInd;

    let dotIndex = targetInd;
    
    if (dotIndex == 0) {
      dotIndex = this.len - 2;
    }

    if (dotIndex == this.len - 1) {
      dotIndex = 1;
    }

    return dotIndex;
  }

  changeHandler(targetInd = 0) {
    // targetInd would be frame index which have 2 more fake frame than dots.
    this.animateHandler(targetInd);


    let dotsIndex = this.getDotsIndex(targetInd) - (this.fakeAddition / 2);
    this.dotHandler(dotsIndex);
    // this.contentHandler(dotsIndex);
    // this.numIndexHandler(dotsIndex);

    if (!this.isInfinite) {
      // this.toggleArrow(dotsIndex)
    }
  }

  touchStart(e) {
    e = e || window.event;
    if (e.type == "touchstart") {
      this.touchPosInitial.x = e.touches[0].clientX;
      this.touchPosInitial.y = e.touches[0].clientY;
    }
  }

  touchMove(e) {
    e = e || window.event;
    if (e.type == "touchmove") {
      this.touchPos.x = e.touches[0].clientX;
      this.touchPos.y = e.touches[0].clientY;
    }

    // if (Math.abs(this.touchPosInitial.x - this.touchPos.x) > 10) {
    //   document.querySelector("body").style.overflow = "hidden";
    // }

    if (this.curIndex == 0 && this.touchPos.x > this.touchPosInitial.x) {
      return ;
    }

    if (this.curIndex == this.len - 1 && this.touchPos.x < this.touchPosInitial.x) {
      return;
    }

    const { frame } = this.elements;

    let movingValue = 0 - this.frameWidth * this.curIndex - this.touchPosInitial.x + this.touchPos.x;

    frame.style.transform = `translate3d(${movingValue}px, 0, 0)`;
  }

  touchEnd(e) {
    // document.querySelector("body").style.overflow = "unset";
    if (this.curIndex == 0 && this.touchPos.x > this.touchPosInitial.x) {
      return ;
    }

    if (this.curIndex == this.len - 1 && this.touchPos.x < this.touchPosInitial.x) {
      return;
    }

    let diff = this.touchPosInitial.x - this.touchPos.x;

    if (Math.abs(diff) < this.movingTreshold) {
      this.changeHandler(this.curIndex);

      return;
    }

    if (diff >= 0) {
      if (this.isChanging) return;

      this.curIndex += 1;

      this.curIndex %= this.len;

      this.changeHandler(this.curIndex);

      return ;
    }

    if (diff < 0) {
      if (this.isChanging) return;

      this.curIndex -= 1;
      if (this.curIndex < 0) {
        this.curIndex = this.len - 1;
      }

      this.changeHandler(this.curIndex);
      
      return;
    }
  }

  animateHandler(targetInd) {
    if (this.isChanging) return;

    const { frame } = this.elements;
    
    this.isChanging = true;

    // frame.style.transition = "transform .9s cubic-bezier(.645, .045, .355, 1)";
    frame.style.transition = "transform 500ms";

    frame.style.transform = `translate3d(${0 - this.frameWidth * targetInd}px, 0, 0)`;

    setTimeout(() => {
      frame.style.transition = null;

      this.curIndex = this.getDotsIndex(targetInd);
      frame.style.transform = `translate3d(${0 - this.frameWidth * this.curIndex}px, 0, 0)`;

      this.isChanging = false;
    }, 500);
  }

  contentHandler(targetInd) {
    const { textBox } = this.elements;

    Object.keys(textBox).forEach(cur => {
      if (textBox[cur]) {
        textBox[cur].textContent = this.content[targetInd][cur];
      }
    });
  }

  dotHandler(targetInd) {
    const { dots } = this.elements;

    if (dots.length == 0) return;

    dots.forEach(cur => {
      cur.classList.remove("selected")
    });

    dots[targetInd].classList.add("selected");
  }

  toggleArrow(targetInd) {
    const { leftArrow, rightArrow } = this.elements;
    leftArrow.classList.remove("hidden");
    rightArrow.classList.remove("hidden");

    if (targetInd == 0) {
      leftArrow.classList.add("hidden");
    }

    if (targetInd == this.len - 1) {
      rightArrow.classList.add("hidden");
    }
  }

  numIndexHandler(targetInd) {
    const { numIndex } = this.elements;

    if (!numIndex) return;

    numIndex.textContent = this.getFormattedNumber(targetInd + 1);
  }

  getFormattedNumber(num) {
    return (num > 10 || num == 0) ? num : "0" + num;
  }
}

document.addEventListener("DOMContentLoaded", function() {
  let sliderCont = document.querySelectorAll("[slider-cont]");
  sliderCont = [...sliderCont];
  
  SliderArr = sliderCont.map(cur => new Slider(cur));
});